module.exports = __webpack_public_path__ + "static/SaltStack_Comply_black-0a5b577eb4ee5e1e37c41c4ac869abc8.png";